import * as originalServices from './servicios';
import { auditServices } from '../auditUtils';

/**
 * Versión auditada de los servicios de clientes
 * 
 * Registra automáticamente cada operación en la auditoría basado en el tipo de acción
 */
const auditedServices = auditServices(originalServices, 'clientes');

export default auditedServices;
